import React, { Component } from 'react';
import { object, array, shape, bool, string, arrayOf } from 'prop-types';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import { I18nextProvider } from 'react-i18next';
import { Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import createStores from '../../stores';
import AppContainer from '../app-container';
import i18n from '../../../i18n';

export default class Root extends Component {
  static propTypes = {
    apiBaseUrl: string.isRequired,
    basename: string.isRequired,
    userId: string.isRequired,
    metaSiteId: string.isRequired,
    embeddedIntegrationsApiBaseUri: string.isRequired,
    i18n: object.isRequired,
    experiments: object.isRequired,
    widgets: array.isRequired,
    premium: shape({
      exist: bool.isRequired,
    }).isRequired,
    locale: string,
    userPermissions: arrayOf(string).isRequired,
  };

  state = {
    isReady: false,
  };

  constructor(props) {
    super(props);
    const {
      i18n: i18nConfig,
      widgets,
      experiments,
      premium,
      locale,
      apiBaseUrl,
      basename,
      userId,
      metaSiteId,
      embeddedIntegrationsApiBaseUri,
      userPermissions,
    } = this.props;

    const browserHistory = createBrowserHistory({ basename });

    this.stores = createStores({
      apiBaseUrl,
      basename,
      userId,
      metaSiteId,
      embeddedIntegrationsApiBaseUri,
      experiments,
      widgets,
      staticsBaseUrl: i18nConfig.staticsBaseUrl,
      browserHistory,
      premium,
      locale,
      userPermissions,
    });

    configure({ isolateGlobalState: true });
  }

  async componentDidMount() {
    const { i18n: i18nConfig } = this.props;
    this.i18Instance = await i18n(i18nConfig);
    this.setState({ isReady: true });
  }

  render() {
    return (
      this.state.isReady && (
        <Router history={this.stores.navigation.history}>
          <I18nextProvider i18n={this.i18Instance}>
            <Provider {...this.stores}>
              <Route component={AppContainer} />
            </Provider>
          </I18nextProvider>
        </Router>
      )
    );
  }
}
